import './intro.scss';
import scrollTrigger from '../../assets/scripts/scrollTrigger';

export default () => {
	scrollTrigger( {
		target: '.js-move-up',
		centered: true,
		animate: function ( target, progress ) {
			if ( window.innerWidth > 640 ) {
				target.style.transform = `translateY(${progress * -100}px)`;
			} else {
				target.style.transform = 'translateY(0)';
			}
		},
	} );

	scrollTrigger( {
		target: '.js-move-down',
		centered: true,
		animate: function ( target, progress ) {
			if ( window.innerWidth > 640 ) {
				target.style.transform = `translateY(${progress * 100}px)`;
			} else {
				target.style.transform = 'translateY(0)';
			}
		},
	} );
};
